'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Break = function Break(_ref) {
    var theme = _ref.theme;
    return _react2.default.createElement('hr', { className: theme.root, 'data-test-tag': '@spp/ui-break' });
};

Break.propTypes = {
    theme: _propTypes2.default.shape({
        root: _propTypes2.default.string
    })
};

Break.defaultProps = {
    theme: {}
};

exports.default = Break;
//# sourceMappingURL=Break.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-break/lib/cjs/Break.js
 ** module id = 575
 ** module chunks = 1
 **/